export const GET_DEVICE_ACTION_TYPE = 'device/getDevice';

export const DEVICE_PROPS = {
  ALERTS: {
    SELECT_STATUS: 'Select Status',
    STATUS: 'Status',
  },
  DEVICE_TYPES: {
    SELECT_DEVICE_TYPE: 'Select Device Type',
    DEVICE_TYPE: 'Device Types',
  },
  SEARCH: {
    PLACEHOLDER: 'Device ID / SN',
  },
  COLUMNS: {
    OPERATOR_ID: 'Operator ID',
    MARKET_ID: 'Market ID',
    DEVICE_ID: 'Device ID',
    SERIAL_NO: 'Serial No',
    TYPE: 'Type',
    LAST_SYNC: 'Last Sync',
    STATUS: 'Status',
    CREATED_ON: 'Created On',
    UPDATED_ON: 'Updated On',
  },
};

export const EAlertStatus = [
  {
    id: 'false',
    name: 'Active',
  },
  {
    id: 'true',
    name: 'Inactive',
  },
];

export const EDeviceType = [
  {
    queryParam: '',
    name: 'All Types',
  },
  {
    queryParam: 'cooler',
    name: 'COOLER',
  },
  {
    queryParam: 'kiosk',
    name: 'KIOSK',
  },
  {
    queryParam: 'pc',
    name: 'PC',
  },
  { queryParam: 'ccr', name: 'CCR' },
];
